/**
 * Editorial content for the Grey Market Premium pages (/ipo-gmp, /sme-ipo-gmp):
 * related-page links and FAQs. The board itself is live (GET /api/market/gmp).
 */

export const RELATED_REPORTS = [
  { label: 'Live IPO Subscription Status', href: '/ipo-subscription' },
  { label: 'Upcoming IPOs & DRHP Pipeline', href: '/upcoming-ipos' },
  { label: 'DRHP & RHP Filings Tracker', href: '/drhp-filings' },
  { label: 'IPO Reviews & Broker Calls', href: '/ipo-reviews' },
  { label: 'SME IPO GMP', href: '/sme-ipo-gmp' },
];

export const GMP_FAQS = [
  {
    question: 'What is Grey Market and GMP in simple terms?',
    points: [
      'The grey market is an unofficial, over-the-counter market where IPO applications and allotted shares change hands before the shares list on the exchange.',
      'GMP (Grey Market Premium) is the extra price, above the upper price band, that informal buyers are willing to pay for an IPO share today.',
      'Because GMP is completely unofficial, there is no exchange involvement and no SEBI oversight — trades rely only on the word of the dealers involved.',
      'The Fire Rating on this board is the source tracker\'s demand rating for the issue, shown as 1 to 5 stars.',
    ],
  },
  {
    question: 'Why am I not getting SME IPO allotment despite heavy subscription?',
    points: [
      'SME IPOs have very large minimum lots, so the retail quota is split into only a few hundred or thousand lots.',
      'When an issue is subscribed hundreds of times, lots are distributed by a computerised lottery — every valid application has the same small chance.',
      'Applying for more than one lot from the same PAN does not improve your odds in the retail category; applying from different family PANs does.',
    ],
  },
  {
    question: 'What is meant by "Seller Only" or "Buyer Only" in GMP quotes?',
    points: [
      '"Seller Only" means dealers are finding sellers but few buyers at the quoted premium — usually a sign the GMP may soften.',
      '"Buyer Only" means demand exceeds supply at the quoted rate, which often precedes a rise in GMP.',
      'Both are short-lived signals and can flip within hours around subscription updates and the basis of allotment.',
    ],
  },
];

// SME GMP page (/sme-ipo-gmp)
export const SME_RELATED_REPORTS = [
  { label: 'SME IPO List: NSE Emerge & BSE SME', href: '/sme-ipos' },
  { label: 'Live SME IPO Subscription Status', href: '/sme-ipo-subscription' },
  { label: 'Upcoming SME IPOs', href: '/sme-upcoming-ipos' },
  { label: 'SME IPO Reviews & Broker Calls', href: '/sme-ipo-reviews' },
  { label: 'All IPO GMP (Mainboard & SME)', href: '/ipo-gmp' },
];

export const SME_GMP_FAQS = [
  {
    question: 'How is SME IPO GMP different from mainboard GMP?',
    points: [
      'SME issues are small, so only a handful of grey market dealers quote them, and a few trades can move the premium sharply in either direction.',
      'GMP is quoted per share, but SME shares are applied for and traded in large lots, so the premium per application is the GMP multiplied by the lot size.',
      'As with every grey market quote, SME GMP is unofficial: there is no exchange involvement and no SEBI oversight behind it.',
    ],
  },
  {
    question: 'How do I read the estimated gain on one SME lot?',
    points: [
      'Estimated gain per lot = GMP × lot size. For example, a ₹12 GMP on a 1,600-share lot points to about ₹19,200 per lot before charges and taxes.',
      'The per-lot value in the SME IPO list shows how much capital one lot needs at the upper price band.',
      'Treat the figure as indicative only; SME listing prices often move away from the last grey market quote.',
    ],
  },
  {
    question: 'Why am I not getting SME IPO allotment despite heavy subscription?',
    points: [
      'SME IPOs have very large minimum lots, so the individual-investor quota is split into only a few hundred or thousand lots.',
      'When an issue is subscribed many times over, lots are distributed by a computerised lottery — every valid application has the same small chance.',
      'Applying for more than one lot from the same PAN does not improve your odds in the individual-investor category; applying from different family PANs does.',
    ],
  },
  {
    question: 'Why can SME GMP disappear before listing?',
    points: [
      'Thin grey market interest means dealers may stop quoting an SME issue altogether, especially after the basis of allotment.',
      'A missing quote on this board means no current rate from the source — not a zero premium.',
    ],
  },
];
